import React from "react";
import { useHistory } from "react-router";
import PeopleIcon from "@atlaskit/icon/glyph/people";
import { URL } from "../../constants/navigation";

import { Button } from "../../UI/Button";
import useAuth from "../../routes/login/AuthContext";
import { handleNavigation } from "../../helpers/handleNavigation";


export const MatchWithAnotherUserButton = () => {
  const { push } = useHistory();
  const { isSuperAdminRead } = useAuth();

  const handleMatchClick = (event: React.MouseEvent) => handleNavigation(event, URL.USERS_MATCH, push);

  return (
    <>
      <Button appearance="primary" iconBefore={<PeopleIcon label="people" />} onClick={handleMatchClick} isDisabled={isSuperAdminRead()}>
        Match With Another User
      </Button>
    </>
  );
};
